import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { UserService } from '../../../common/services/User.service';
import { GroupService } from '../../../common/services/Group.service';
import { BaseListComponent } from '../../base-list.component';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SearchService } from '../../../common/services/Search.service';
import { AgentModelConst } from '../agent-modal/agent-modal.const';
import { Observable } from 'rxjs/Observable';
import { ModalType } from '../modal.const';
import { MergeModalConst, MergeModalType } from './merge-modal.const';
import { TicketsConst } from '../../../pages/admin/icontact/tabs/user/tickets/tickets.const';
import { ContactsConst } from '../../../pages/admin/icontact/tabs/organize/contacts/contacts.const';
import { TicketService } from '../../../common/services/Ticket.service';
import { ContactService } from '../../../common/services/Contact.service';

@Component({
  selector: 'app-merge-modal',
  templateUrl: './merge-modal.component.html',
  styleUrls: ['./merge-modal.component.css'],
  providers: [UserService, GroupService],
})
export class MergeModalComponent extends BaseListComponent {
  @Input() content: any = { type: ModalType.Primary, title: 'Modal' };
  @Input() type: any = MergeModalType.Ticket;
  @Input() options: any = {};

  @Output() onCloseModal = new EventEmitter<any>();
  @Output() onActionModal = new EventEmitter<any>();

  public customActionModal: any = [];
  public lstAgents: any[] = [];
  public allAgents: any[] = [];
  public allStatus: any[] = [];
  public dataToMerge: any[] = [];
  public allSources = [
    { id: '', text: 'Nguồn khởi tạo' },
    { id: 'CALL_OUTBOUND', text: 'Gọi điện ra' },
    { id: 'CALL_INBOUND', text: 'Khách gọi điện' },
    { id: 'chat', text: 'Tin nhắn web' },
    { id: 'hand', text: 'Thêm mới' },
    { id: 'zalo', text: 'Zalo' },
    { id: 'email', text: 'Email' },
    { id: 'facebook', text: 'Kênh Facebook' },
  ];
  public modelFilter: any = {
    keyword: '',
    status: '',
    source_detail: '',
    assign_agent_id: '',
    source: '',
  };
  public readonly MergeModalType = MergeModalType;

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected modalService: BsModalService,
    protected toastr: ToastrService,
    private userService: UserService,
    private groupService: GroupService,
    private searchService: SearchService,
    private ticketService: TicketService,
    private contactService: ContactService
  ) {
    super(changeDetector, toastr, modalService);
  }

  async ngOnInit() {
    this.displayColumns = MergeModalConst.displayColumns(this.type);
    this.customActionModal = MergeModalConst.getModalAction();
    Observable.forkJoin([this.userService.list(), this.ticketService.status()]).subscribe(data => {
      this.loadUsers(data[0]);
      this.loadStatus(data[1]);
      this.loadData();
    });
  }

  async reloadFilter() {
    this.modelFilter = {
      keyword: '',
      status: '',
      source_detail: '',
      assign_agent_id: '',
      source: '',
    };
    this.currentPage = 1;
    await this.loadData();
  }

  loadUsers(res) {
    if (res.status == 200 && !res.error) {
      this.lstAgents = res.data.list;
      if (this.lstAgents && this.lstAgents.length > 0) {
        const agents =
          this.lstAgents.map(a => {
            return {
              text: a.name,
              id: a._id,
            };
          }) || [];
        this.allAgents = [{ id: '', text: 'Chuyên viên' }, ...agents];
      }
    }
  }

  loadStatus(res) {
    if (res.status == 200 && !res.error) {
      const statusList = [];
      res.data.forEach((c: any) => {
        statusList.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allStatus = statusList;
    }
  }

  async changeFilter(key, $event) {
    let value = $event.target.value;
    if (value === '-1' || value === 'Chọn') {
      value = '';
    }
    this.modelFilter[key] = value;
    this.currentPage = 1;
    this.loadData();
  }

  async changeSelect2Filter(key, $event) {
    let value = $event.value;
    if (value === '-1' || value === 'Chọn') {
      value = '';
    }
    this.modelFilter[key] = value;
  }

  async loadData() {
    switch (this.type) {
      case MergeModalType.Ticket:
        await this.loadTicket();
        break;
      case MergeModalType.Contact:
        await this.loadContact();
        break;
    }
  }

  async loadTicket() {
    const { _id, requester_id } = this.options;
    const params = {
      source: 'all',
      limit: this.page_size,
      offset: this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1),
      sort_by: 'updated_at:desc',
    };
    if (_id) {
      let must: any = [];
      if (requester_id) {
        must.push({ term: { requester_id: requester_id } });
      }
      if (this.modelFilter.status) {
        must.push({ term: { status: this.modelFilter.status } });
      }
      if (this.modelFilter.source_detail) {
        must.push({ match: { source_detail: this.modelFilter.source_detail } });
      }
      if (this.modelFilter.assign_agent_id) {
        must.push({
          match: { assign_agent_id: this.modelFilter.assign_agent_id },
        });
      }
      const condition: any = {
        must: [],
      };
      if (must && must.length > 0) {
        condition.must.push({ bool: { must: must } });
      }
      if (this.modelFilter.keyword) {
        let should: any = [
          { match_phrase: { subject: this.modelFilter.keyword } },
          { match_phrase: { code: this.modelFilter.keyword } },
        ];
        condition.must.push({
          bool: {
            should: should,
            minimum_should_match: 1,
          },
        });
      }
      condition.must.push({
        bool: {
          must_not: {
            term: { _id: _id },
          },
        },
      });
      const body = {
        condition: JSON.stringify(condition),
        active_fields: ['assign_agent_id', 'requester_id'],
        type: 'ticket',
        label: 'and',
        sub_label: 'and',
        keyword: '',
        force_search: 'customer',
      };
      const payload = await this.buildBasePayload(body, {});
      this.searchService.list(params, payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.data = res.data.res.list;
            this.data = this.data.map(e => {
              e.display_code = MergeModalConst.displayCodeColumns(e);
              e.display_subject = MergeModalConst.displaySubjectColumns(e, this.user);
              e.display_assignee = MergeModalConst.displayAssigneeColumns(e, this.lstAgents);
              e.display_source = MergeModalConst.displaySourceTicketColumn(e);
              e.display_status = MergeModalConst.displayStatusColumns(e);
              e.display_btn_action_status = true;
              return e;
            });
            this.initPage(res.data.res.total);
          } else {
            this.data = [];
          }
        },
        error => {
          this.data = [];
        }
      );
    }
  }

  async loadContact() {
    const { _id } = this.options;
    if (_id) {
      const must: any = [];
      if (this.modelFilter.source) {
        must.push({ match: { source: this.modelFilter.source } });
      }

      const condition: any = {
        must: [],
      };
      if (must && must.length > 0) {
        condition.must.push({
          bool: {
            must: must,
          },
        });
      }
      if (this.modelFilter.keyword) {
        let should: any = [
          { match_phrase: { name: this.modelFilter.keyword } },
          { match_phrase: { email: this.modelFilter.keyword } },
          { match_phrase: { phone: this.modelFilter.keyword } },
        ];
        condition.must.push({
          bool: {
            should: should,
            minimum_should_match: 1,
          },
        });
      }
      condition.must.push({
        bool: {
          must_not: {
            term: { _id: _id },
          },
        },
      });
      const body = {
        condition: JSON.stringify(condition),
        active_fields: '',
        type: 'user',
        label: 'and',
        sub_label: 'and',
        keyword: '',
        force_search: 'customer',
      };
      const payload = await this.buildBasePayload(body, {});
      this.searchService.all(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.data = res.data.list;
            this.data = this.data.map(e => {
              e.display_name = ContactsConst.displayNameColumns(e, this.user);
              e.display_phone = ContactsConst.displayPhoneColumns(e, this.user);
              e.display_email = ContactsConst.displayEmailColumns(e);
              e.display_source = ContactsConst.displaySourceColumns(e);
              e.display_btn_action_status = true;
              return e;
            });
            this.initPage(res.data.total);
          } else {
            this.data = [];
          }
        },
        error => {
          this.data = [];
        }
      );
    }
  }

  async handleAction(type, item?: any) {
    if (type === 'mergeAll') {
      this.dataToMerge = this.lstChecked;
    } else if (type === 'merge') {
      this.dataToMerge = [item._id];
    }
    await this.confirmMerge();
  }

  async confirmMerge() {
    let conf;
    const length = this.dataToMerge.length;
    switch (this.type) {
      case MergeModalType.Ticket:
        if (length === 0) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Cần ít nhất 1 ticket để hợp nhất',
          };
          return;
        }
        conf = confirm('Bạn có chắc chắn muốn hợp nhất ' + length + ' Ticket không?');
        if (conf) {
          await this.submitMergeTicket();
        }
        break;
      case MergeModalType.Contact:
        if (length === 0) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Cần ít nhất 1 khách hàng để hợp nhất',
          };
          return;
        }
        conf = confirm('Bạn có chắc chắn muốn hợp nhất ' + length + ' khách hàng không?');
        if (conf) {
          await this.submitMergeContact();
        }
        break;
    }
  }

  async submitMergeTicket() {
    const { _id } = this.options;
    if (_id) {
      const payload = {
        ticket_id: _id,
        merge_ticket_ids: this.dataToMerge,
      };
      this.setLoading(true);
      this.ticketService.merges(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            setTimeout(() => {
              this.loadData();
              this.lstChecked = [];
              this.setLoading(false);
              this.throwSuccess('Hợp nhất ticket thành công!');
              this.onActionModal.emit();
            }, 3000);
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
            this.setLoading(false);
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
          this.setLoading(false);
        }
      );
    }
  }

  async submitMergeContact() {
    const { _id } = this.options;
    if (_id) {
      const payload = {
        user_id: _id,
        merge_user_ids: this.dataToMerge,
      };
      this.setLoading(true);
      this.contactService.merges(payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            setTimeout(() => {
              this.loadData();
              this.lstChecked = [];
              this.setLoading(false);
              this.throwSuccess('Hợp nhất khách hàng thành công!');
              this.onActionModal.emit();
            }, 3000);
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
            this.setLoading(false);
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
          this.setLoading(false);
        }
      );
    }
  }

  closeModal() {
    this.onCloseModal.emit(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/merge-modal/merge-modal.component.ts